<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>$organizations</v-icon>
      </v-btn>
    </template>

    <v-list
      :tile="false"
      nav
    >
      <v-text-field
        v-if="Object.values(organizations).length > 10"
        v-model="search"
        append-icon="$search"
        class="ml-auto"
        hide-details
        :label="$t('search_records')"
        single-line
        autofocus
      />
      <v-list-item-group
        v-model="profile.organization.id"
        color="primary"
      >
        <v-list-item
          v-for="(organization) in organizations_filtered"
          :key="organization.id"
          :value="organization.id"
        >
          <v-list-item-avatar>
            <v-img
              :src="'data:image/jpeg;base64,' + (organization.avatar ? organization.avatar.thumbnail : null)"
            />
          </v-list-item-avatar>
          <v-list-item-content
            @click="changeOrganization({organization_id: organization.id})"
          >
            <v-list-item-title v-text="organization.name" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
  // Utilities
  import { get, call } from 'vuex-pathify'

  export default {
    name: 'OrganizationSelector',
    data: () => ({
      selectedItem: 2,
      search: '',
    }),
    computed: {
      profile: get('auth/profile'),
      organizations: get('auth/organizations'),
      organizations_filtered () { return Object.values(this.organizations).filter(o => o.name.toLowerCase().includes(this.search.toLowerCase())) },
    },
    watch: {
      search: {
        handler () {
          // const res = this.profile.organization.modules.filter(m => m.name === 'glider').length > 0 // this.profile.can.filter() // .filter(org => name.indexOf('farkas') > -1)
          // console.log(Object.values(this.organizations).filter(m => m.name === '12345').length > 0)
          // .filter()
          // console.log('A profil változott!!!!')
        },
        deep: true,
      },
    },
    methods: {
      changeOrganization: call('auth/changeOrganization'),
    },
  }
</script>
